/**
 * 支付相关的工具函数
 */

import type { PaymentCheckStatusResponse, PaymentOrderListItem } from '@/https/types/payments'

// 支付相关常量
export const PAYMENT_CONSTANTS = {
    POLLING_INTERVAL: 3000, // 3秒轮询间隔
    MAX_FAIL_COUNT: 3,      // 最大失败次数
    DEFAULT_TIMEOUT: 300    // 默认超时时间（5分钟）
} as const

/**
 * 将 PaymentCheckStatusResponse 转换为 PaymentOrderListItem 格式
 */
export function convertCheckStatusToListItem(
    status: PaymentCheckStatusResponse
): Partial<PaymentOrderListItem> {
    return {
        id: status.order_id,
        order_no: status.order_no,
        status: status.status,
        updated_at: status.updated_at,
        pay_at: status.pay_at,
        countdown_seconds: status.countdown_seconds.toString(),
        is_timeout: status.is_timeout.toString(),
        can_cancel: status.can_cancel.toString()
    }
}

/**
 * 格式化倒计时显示
 */
export function formatCountdownTime(seconds: number): string {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${mins}:${secs.toString().padStart(2, '0')}`
}

/**
 * 打开富呗支付宝授权页。
 * 移动端普通浏览器里直接访问 openauth 会提示“请在支付宝客户端打开链接”，
 * 因此优先使用支付宝 Scheme 拉起客户端，未拉起时再回落到原网页。
 */
export function openAlipayAuthUrl(authUrl: string, isMobile = false): void {
    const userAgent = window.navigator.userAgent.toLowerCase()
    const isAlipayClient = userAgent.includes('alipayclient')

    if (!isMobile || isAlipayClient) {
        window.location.href = authUrl
        return
    }

    const alipaySchemeUrl = `alipays://platformapi/startapp?appId=20000067&url=${encodeURIComponent(authUrl)}`
    let fallbackTimer = 0

    const clearFallback = () => {
        if (fallbackTimer) {
            window.clearTimeout(fallbackTimer)
            fallbackTimer = 0
        }
        document.removeEventListener('visibilitychange', handleVisibilityChange)
        window.removeEventListener('pagehide', clearFallback)
    }

    const handleVisibilityChange = () => {
        if (document.hidden) {
            clearFallback()
        }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    window.addEventListener('pagehide', clearFallback)
    fallbackTimer = window.setTimeout(() => {
        clearFallback()
        window.location.href = authUrl
    }, 1600)

    window.location.href = alipaySchemeUrl
}
